import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";

const flow = {
  A: { label: "Active", color: "hubColors.greenMain" },
  T: { label: "Terminated", color: "hubColors.redMain" },
  O: { label: "Other", color: "hubColors.grey" },
  L: { label: "Leave of Absence", color: "hubColors.yellowMain" },
};
const UsersStatusChip = ({ item }) => {
  const label = item?.status || "A";
  const final = flow[label];

  return (
    <Stack
      sx={{
        padding: "2px 7px",
        border: "1px solid",
        borderColor: "hubColors.greyLight",
        borderRadius: "5px",
        flexDirection: "row",
        gap: "5px",
        alignItems: "center",
        width: "min-content",
      }}
    >
      <Box
        width="6px"
        height="6px"
        borderRadius="6px"
        backgroundColor={final.color}
      />
      <Typography variant="caption11">{final.label}</Typography>
    </Stack>
  );

  // return (
  //   <Chip
  //     label={final.label}
  //     variant="colorTag"
  //     flow={final.color}
  //     sx={{
  //       "& .MuiChip-label": {
  //         fontSize: 10,
  //       },
  //     }}
  //   />
  // );
};

export default UsersStatusChip;
